var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6865",
    "data-name": "Path 6865",
    d: "M47,9a1,1,0,1,0-1-1,1,1,0,0,0,1,1Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6866",
    "data-name": "Path 6866",
    d: "M43,9a1,1,0,1,0-1-1,1,1,0,0,0,1,1Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6867",
    "data-name": "Path 6867",
    d: "M39,9a1,1,0,1,0-1-1,1,1,0,0,0,1,1Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6868",
    "data-name": "Path 6868",
    d: "M59,31H52V6.74A2.7,2.7,0,0,0,49.34,4H4.66A2.7,2.7,0,0,0,2,6.74V37.26A2.7,2.7,0,0,0,4.66,40H32V57a3,3,0,0,0,3,3H59a3,3,0,0,0,3-3V34a3,3,0,0,0-3-3Zm-8,8H43V33h8ZM4.66,6H49.34a.7.7,0,0,1,.66.74V10H4V6.74A.7.7,0,0,1,4.66,6Zm0,32A.7.7,0,0,1,4,37.26V12H50V31H35a3,3,0,0,0-3,3v4ZM60,57a1,1,0,0,1-1,1H35a1,1,0,0,1-1-1V34a1,1,0,0,1,1-1h6v6a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V33h6a1,1,0,0,1,1,1Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6869",
    "data-name": "Path 6869",
    d: "M56,47H46a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H56a2,2,0,0,0,2-2V49A2,2,0,0,0,56,47ZM46,52V49H56l0,3Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6870",
    "data-name": "Path 6870",
    d: "M57,55H51a1,1,0,1,0,0,2h6a1,1,0,1,0,0-2Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6871",
    "data-name": "Path 6871",
    d: "M47,55H45a1,1,0,1,0,0,2h2a1,1,0,1,0,0-2Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6872",
    "data-name": "Path 6872",
    d: "M32,30a3.847,3.847,0,0,0,3.832-3h3.337A3.847,3.847,0,0,0,43,30a4,4,0,1,0,0-8,3.847,3.847,0,0,0-3.832,3H35.832c-.838-3.952-6.828-3.948-7.663,0H24.832c-.838-3.952-6.828-3.948-7.663,0H13.832A3.847,3.847,0,0,0,10,22a4,4,0,1,0,0,8,3.847,3.847,0,0,0,3.832-3h3.337c.838,3.952,6.827,3.948,7.663,0h3.337A3.847,3.847,0,0,0,32,30Zm11-6a2,2,0,1,1-2,2,2,2,0,0,1,2-2ZM32,24a2,2,0,1,1-2,2,2,2,0,0,1,2-2ZM10,28a2,2,0,1,1,2-2,2,2,0,0,1-2,2Zm11,0a2,2,0,1,1,2-2,2,2,0,0,1-2,2Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6873",
    "data-name": "Path 6873",
    d: "M31.292,20.706a1.014,1.014,0,0,0,1.417,0l2-2a1,1,0,1,0-1.414-1.414L33,17.586V14a1,1,0,0,0-2,0v3.586l-.293-.293a1,1,0,1,0-1.414,1.414Z",
    transform: "translate(-2 -4)",
    fill: "#d40511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/appIcon.2e911c99b9717cdd9bc91deba6f4b07d.svg";
export { ForwardRef as ReactComponent };